import { CommonError } from '../../types';
import { ChartActions } from './actions';
import { FETCH_CHARTS_FAILURE, FETCH_CHARTS_REQUEST, FETCH_CHARTS_SUCCESS } from './constants';
import { ChartData } from './types';

export interface ChartState {
    chartDatas: ChartData[];
    loading: boolean;
    error: CommonError | null;
}
const initialState = {
    chartDatas: [],
    loading: false,
    error: null,
};
export const chartReducer = (state = initialState, action: ChartActions): ChartState => {
    switch (action.type) {
        case FETCH_CHARTS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_CHARTS_SUCCESS: {
            return { ...state, loading: false, chartDatas: action.payload };
        }
        case FETCH_CHARTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
